<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo"  @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID：">
                <el-input style="width: 150px;" v-model.trim="searchForm.iccid" @keyup.enter.native="getListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="退款状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option label="待处理" value="0"></el-option>
                    <el-option label="审核通过（打款）" value="1"></el-option>
                    <el-option label="审核通过（不打款）" value="2"></el-option>
                    <el-option label="审核不通过" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListPageHandle">搜 索</el-button>
                <el-button type="primary" @click="bacthBackUser" plain><i></i> 批量审核退款</el-button>
                <el-button type="success" icon="el-icon-download" plain @click="confirmExportDialogVisible = true">导 出</el-button>
            </el-form-item>
        </el-form>
        <el-table 
		:data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		  :default-sort = "{prop: 'rpTime', order: 'descending'}"  @selection-change="handleSelectionChange"
		  > 
          <el-table-column type="selection" width="55" />
            <el-table-column prop="orderNo" align="center" width="200" label="订单号" show-overflow-tooltip></el-table-column>
            <el-table-column label="ICCID号" show-overflow-tooltip align="center" width="200">
                <template slot-scope="scope"> 
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="priceRmb" label="订单金额（元）" align="center" width="110"></el-table-column>
             <el-table-column  label="申请退款原因" width="170" align="center" show-overflow-tooltip>
                <template v-slot="scope">
                    <el-tooltip  class="item" effect="dark" :content="scope.row.rqReason">
                        <p> {{scope.row.rqReason}}</p>
                    </el-tooltip>
    
                </template> 
            </el-table-column>
            <el-table-column prop="createTime" align="center" label="申请退款时间" show-overflow-tooltip width="140"></el-table-column>
            <el-table-column prop="createOptName" align="center" label="申请人" width="70"></el-table-column>
             <el-table-column prop="loadUserName" align="center" label="操作人" width="70"></el-table-column>
            <el-table-column prop="stateName" align="center" label="退款状态" width="100"></el-table-column>
            <el-table-column prop="rpTime" align="center" label="审核时间" show-overflow-tooltip sortable width="140"></el-table-column>
            <el-table-column prop="rpReason" label="审核结果" align="center" width="120"></el-table-column>
            <el-table-column prop="realPriceRmb" label="实际退款金额（元）" width="130" align="center"></el-table-column>
            <el-table-column label="操作" width="120" align="center" fixed="right">
                <template slot-scope="scope" >
                    <el-button type="text" size="small" @click="showBackMoneyDetailDialog(scope.row.orderNo, $event)">详情</el-button>
                    <el-button type="text" size="small"  @click="showBackMoneyConfirm(scope.row)" v-show="scope.row.state==0">审核</el-button>
                    <el-button type="text" size="small" @click="showComplainatPhotos(scope.row)" v-show="scope.row.state!=0">
						<span style="color: #67c23a;">
							证据截图
						</span>
					</el-button>
                </template>            
            </el-table-column>
        </el-table>       
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            :current-page="tbpg.currentPage"
            :page-sizes="[10,20,30, 40]"
            :page-size="tbpg.pageSize"
            :total="tbpg.total"
            background layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
        <el-dialog :append-to-body="true"  title="退款详情" :visible.sync="backMoneyDetailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :header-cell-style="{background:'#f5f5f5'}" :data="tbpg_back.tableData" border height="421">
                <el-table-column prop="orderNo" align="center" label="订单号" width="240"></el-table-column>
                <el-table-column prop="agentName" align="center" label="代理商名称"></el-table-column>
                <el-table-column prop="commissionRmb" align="center" label="退款金额（元）"></el-table-column>
                <el-table-column prop="remark" align="center" label="退款原因"></el-table-column>
            </el-table> 
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_back.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_back.pageSize"
                background layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_back.total">
            </el-pagination> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="backMoneyDetailVisible = false">关 闭</el-button>
            </span>  
        </el-dialog>

        <el-dialog :append-to-body="true"  title="退款审核" :visible.sync="backMoneyConfirmVisible" width="1000px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订&nbsp;单&nbsp;号：</label>
                <span>{{backMoneyConfirmDate.orderNo}}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{backMoneyConfirmDate.iccid}}</span>
            </div>

            <div class="lineInDialog">
                <label>套餐总流量：</label>
                <span>{{fluxMtoG(backMoneyConfirmDate.flowRate)}} G </span>
            </div>

            <div class="lineInDialog">
                <label>已使用流量：</label>
                <span>{{fluxMtoG(backMoneyConfirmDate.usedFlowRate)}} G</span>
            </div>

            <div class="lineInDialog">
                <label>剩余流量：</label>
                <span>{{fluxMtoG(backMoneyConfirmDate.flowRate - backMoneyConfirmDate.usedFlowRate)}} G</span>
            </div>

            <div class="lineInDialog">
                <label>订单金额：</label>
                <span>{{backMoneyConfirmDate.priceRmb}} 元</span>
            </div>


            <div class="lineInDialog">
                <label>证据截图：</label>
                <el-image v-for="url in complainatPhotos" 
                class="complainatPhotos"
                :key="url" :src="url" 
                :preview-src-list="complainatPhotos" lazy></el-image>
            </div>

            <div class="lineInDialog" :rules="isBackRules">
                <label class="label-defined" prop="isBack">审核结果：</label>
                <div style="display: inline-block; line-height: 32px;">
                    <el-radio-group v-model="backMoneyConfirm.isBack">
                        <el-radio :label="1">同意（打款）</el-radio>
                        <el-radio :label="0">同意（不打款）</el-radio>
                        <el-radio :label="2">拒绝</el-radio>
                    </el-radio-group>
                </div>
                
            </div>

            <div class="lineInDialog" v-show="backMoneyConfirm.isBack==0||backMoneyConfirm.isBack==1">
                <label class="label-defined">退款金额：</label>
                <el-input-number v-model="backMoneyConfirm.backPriceRmb" :precision="2" :step="1" :min="0.00" 
                :max="backMoneyConfirmDate.priceRmb"></el-input-number><label class="label-defined text-align-left" >&nbsp;元</label>
            </div>
            <div class="lineInDialog" >
                <label v-show="backMoneyConfirm.isBack!=2">同意备注：</label>
                <label v-show="backMoneyConfirm.isBack==2">拒绝理由：</label>
                <el-input  type="textarea" placeholder="请输入内容" :rows="5" v-model.trim="backMoneyConfirm.rpReason" clearable></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeBackMoneyConfirm">取 消</el-button>
                <el-button type="primary" @click="confirmDialogVisible = true">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog :append-to-body="true"  title="证据截图" :visible.sync="complainatPhotosVisible" width="1000px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>订&nbsp;单&nbsp;号：</label>
                <span>{{backMoneyDetail.orderNo}}</span>
            </div>
            <div class="lineInDialog">
                <label>ICCID号：</label>
                <span>{{backMoneyDetail.iccid}}</span>
            </div>

            <div class="lineInDialog">
                <label>证据截图：</label>
                <el-image v-for="url in backMoneyDetail.complainatPhotos" 
                class="complainatPhotos"
                :key="url" :src="url" 
                :preview-src-list="backMoneyDetail.complainatPhotos" lazy></el-image>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="complainatPhotosVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmDialogVisible"
            width="30%">
            <span v-show="backMoneyConfirm.isBack!=2">确定同意退款吗</span>
            <span v-show="backMoneyConfirm.isBack==2">确定拒绝退款吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleBackMoney">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportInfoHandle">确 定</el-button>
            </span>
        </el-dialog>







        <el-dialog :append-to-body="true" title="批量退款" :visible.sync="backFlg" width="600px" @close="endTimecancel"
            :close-on-click-modal="false">
            <el-form ref="bacthBackData" :model="bacthBackData" label-width="120px">
                <p style="color: red; font-weight:bold">注意：本次操作预计数量{{ bacthBackData.allSize }}/条</p>
                <div class="lineInDialog">
                    <label class="label-defined" prop="isBack">审核结果：</label>
                    <div style="display: inline-block; line-height: 32px;">
                        <el-radio-group v-model="bacthBackData.backType">
                            <el-radio :label="1">同意（打款）</el-radio>
                            <el-radio :label="0">同意（不打款）</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="lineInDialog">
                    <label class="label-defined" prop="isBack">扣除比列：</label>
                    <div style="display: inline-block; line-height: 32px;">
                        <el-radio-group v-model="bacthBackData.backUserType">
                            <el-radio :label="1">按使用流量</el-radio>
                            <el-radio :label="0">按充值金额</el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="lineInDialog" v-if="bacthBackData.backUserType == 0">
                    <label class="label-defined">退款比列：</label>
                    <el-input-number v-model="bacthBackData.backParent" :precision="2" :step="1" :min="0.00"
                        :max="100"></el-input-number><label class="label-defined text-align-left">&nbsp;%</label>
                </div>
                <div class="lineInDialog" v-if="bacthBackData.backUserType == 1">
                    <label class="label-defined">每G金额：</label>
                    <el-input-number v-model="bacthBackData.backParent" :precision="2" :step="1" :min="0.00"
                        :max="100"></el-input-number><label class="label-defined text-align-left">&nbsp;元/G</label>
                    <p style="color: red; font-weight:bold">注意：不满足1G按1G扣费</p>
                </div>

                <el-form-item label="退款备注：" prop="remark">
                    <el-input type="textarea" v-model="bacthBackData.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="endTimecancel">取 消</el-button>
                <el-button type="primary" @click="sureToBackUrl">确 定</el-button>
            </div>
        </el-dialog>



    </div>
</template>
<script>
import {backMoneyList, getSecondBackList, unAgreeBackMoney, agreeBackMoney } from '@/api/order.js'
import {exportBackMoneyApplyInfo } from '@/api/csm.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            //搜索条件
            searchForm: {
                agentName: '',
                supplierCode: '',
                iccid: '',
                orderNo: '',
                time: '',
                state:'',
                backOrderNo:''
            },
            //各级供应商
            branchSupplierOption: [],
            //退款审核订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            //退款详情
            tbpg_back: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },          
            complainatPhotos:[],//退款证据截图数组
            confirmDialogVisible : false,//确认框
            backMoneyDetailVisible: false, //退款详情框

            backMoneyConfirmVisible:false,//退款审核框
            backMoneyConfirm:{
                id:'',
                backPriceRmb:'',
                isBack:1,
                rpReason:''
            },
            backMoneyConfirmDate:{},

            complainatPhotosVisible: false,//证据截图显示框
            backMoneyDetail: {//退款详情对象
                orderNo:'',
                iccid:'',
                complainatPhotos:[],//退款证据截图数组
            },

            isBackRules: {
                isBack: [
                    {required: true, message: '请选择同意或拒绝', trigger: 'blur'}
                ]
            },
            confirmExportDialogVisible: false,

            bacthBackData: {
                backUserType: 1,//0按充值比列 1使用流量比列
                allOrder: '', //多个订单号以-拼成字符串 如A-B-C
                allSize: '0', //选中的数量
                backParent: '',// 退款比列
                backType: 1,// 1审核通过打款  2 审核通过不打款
                remark:'',
            },
            backFlg: false,
            batchData:{
                allOrder:'',
                allSize:'0',
            },
            multipleSelection: [],
        }
    },
    methods: {
        endTimecancel() {
            this.backFlg = false;
            this.$refs.bacthBackData.resetFields();
        },
        reloadSearch() {
            this.searchForm = {};
            this.getOrderListHandle();
        },
        handleSelectionChange(data) {
            this.multipleSelection = data;
        },
        bacthBackUser() {
            this.bacthBackData.allSize = this.multipleSelection.length
            this.bacthBackData.allOrder = this.multipleSelection.map(item => {
                return item.id
            }).join('-')
            if (!this.bacthBackData.allOrder) {
                this.$message.error('请勾选操作订单号！');
                return;
            }
            this.backFlg = true;
        },
        sureToBackUrl() {
            common.sysRequest('order/batch/back/sheng', this.bacthBackData, 'post').then(res => {
                if (res.data.code === '200') {
                    this.$message.success(res.data.message);
                    this.getListPageHandle();
                    this.endTimecancel();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },


        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            backMoneyList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
            if(this.backVisible){
                this.tbpg_back.pageSize = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.pageSize = val;
                this.getListPageHandle();
            }

        },
        handleCurrentChange(val){
            if(this.backVisible){
                this.tbpg_back.currentPage = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.currentPage = val
                this.getListPageHandle();                
            }
        },
        //“退款详情”对话框 
        showBackMoneyDetailDialog(orderNo, $event){
            this.currentOrderNo_back = orderNo
            var searchForm = {
                orderNo: this.currentOrderNo_back
            }
            common.resetCurrentPage(this, $event, 'tbpg_back');
            var data = common.getRequestParams(this, 'tbpg_back', searchForm);
            getSecondBackList(data).then(res => {
                common.listCallback(this, res, 'tbpg_back');

               
                this.backMoneyDetailVisible = true;
            })
        },
        //退款审核对话框
        showBackMoneyConfirm(row){
            common.sysRequest("order/applyRefund/detail", {id: row.id}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.backMoneyConfirmDate = res.data.data;
                    let photosArray = res.data.data.payImgUrl.split("@@");
                    for(let i=0; i<photosArray.length; i++){
                        this.complainatPhotos[i] = process.env.VUE_APP_IMG_URL + '/' + photosArray[i];
                    }

                    this.backMoneyConfirm.backPriceRmb = (res.data.data.flowRate - res.data.data.usedFlowRate)*res.data.data.priceRmb/res.data.data.flowRate;
                    this.backMoneyConfirmVisible = true;
                    
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
            
        },
        closeBackMoneyConfirm(){
            this.backMoneyConfirmVisible = false;
            this.backMoneyConfirm.backPriceRmb = '';
        },

        exportInfoHandle(){
            exportBackMoneyApplyInfo(this.searchForm).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                }else{
                    this.$message.error(res.data.msg);
                }
                this.confirmExportDialogVisible = false;
            }).catch(err=>console.error(err));
        },
        
        handleBackMoney(){
            let params = {};
            params.id = this.backMoneyConfirmDate.id;
            params.backPriceRmb = this.backMoneyConfirm.backPriceRmb;
            params.rpReason = this.backMoneyConfirm.rpReason;
            if(this.backMoneyConfirm.isBack!=2){
                params.isBack = this.backMoneyConfirm.isBack;
            }

            //js对象转format-data
            const data = new FormData();
            Object.keys(params).forEach((key) => {
                data.append(key, params[key]);
            });

            if(this.backMoneyConfirm.isBack != 2){//同意
                agreeBackMoney(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getListPageHandle();
                    }else{
                        this.$message.error(res.data.message)
                    }
                    this.confirmDialogVisible = false;
                    this.backMoneyConfirmVisible = false;
                });
            }else if(this.backMoneyConfirm.isBack == 2){//拒绝
                unAgreeBackMoney(params).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getListPageHandle();
                    }else{
                        this.$message.error(res.data.message)
                    }
                    this.confirmDialogVisible = false;
                    this.backMoneyConfirmVisible = false;
                });
            }

            this.backMoneyConfirm.backPriceRmb = '';
        },

        //证据截图对话框
        showComplainatPhotos(row){
            this.complainatPhotosVisible = true;
            this.backMoneyDetail.orderNo = row.orderNo;
            this.backMoneyDetail.iccid = row.iccid;
            this.backMoneyDetail.orderNo = row.orderNo;

            let photosArray = row.payImgUrl.split("@@");
            for(let i=0; i<photosArray.length; i++){
                this.backMoneyDetail.complainatPhotos[i] = process.env.VUE_APP_IMG_URL + '/' + photosArray[i];
            }
        },
    
    },
    created () {
        this.getListPageHandle();
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
    } 
}
</script>
<style lang="less" scoped>
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }
    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}

.lineInDialog{
    display: flex;
    align-items: center;
}

.label-defined{
    display: inline-block;
    height: 32px;
    line-height: 32px;
}

.select-defined{
    max-width:200px;
}
.text-align-left{
    text-align: left;
}
</style>

